import Filter from "./Filter";


export const AndOrSelectIndicator = (filter: Filter) => {

    let div: HTMLDivElement = document.createElement('div') as HTMLDivElement;

    const updateDescription = (filter: Filter) => {
        div.innerHTML = filter.andOrSelection === 'and' ? 'i' : 'lub';
    }

    div.classList.add('filter-description-item');
    div.classList.add('filter-description-item--and-or-select-indicator');
    updateDescription(filter);

    return {
        element: div,
        update: (filter: Filter) => {
            updateDescription(filter);
        }
    }

}